
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"76","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 64.5l8.5-18 12.5-17m0 3.5l14.5 6M17 48l15 6m15.5-14l-5 19v11l26-2m-21-11L63 55.5m-12.5-11l14.5-1L77.5 40m1 12L85 74M72.5 53l8-2.5L93 48l3.5 7-14.307 9.5M85 62l22 5m-8.5-23.5l12.5-7 14-4 2 8.5-12.5 7m3 1.5l20 5.5M101 32.5L113.5 52l4 9.5m17.5-41l4 17.5 7.5 14 5-1 11-12.5m0 0l-6.5-25m6.5 25l3 13.5m11.5-2.5l-6-29 3.5-15h3.5l3.5 8 2 11 4-14.5 3-6h2l3 6v15.5l-4 28","stroke":"#F5314B","stroke-width":"8"}})])
          )
        }
      }
    